import type { TaskInfo } from './types';

export function hasVncTarget(task: TaskInfo): boolean {
  if (typeof task.viewPort === 'number' && task.viewPort > 0) return true;
  return typeof task.ip === 'string' && task.ip.length > 0;
}
